import Alpine from 'alpinejs'

Alpine.data('meetJoin', () => ({
  rawCode: '',
  bgColor: '#06b6d4',

  get displayCode() {
    const c = this.rawCode
    if (c.length <= 3) return c
    if (c.length <= 7) return `${c.slice(0, 3)}-${c.slice(3)}`
    return `${c.slice(0, 3)}-${c.slice(3, 7)}-${c.slice(7)}`
  },

  set displayCode(_) {
    // handled by handleInput
  },

  get isValid() {
    return this.rawCode.length === 10
  },

  handleInput(e) {
    const raw = e.target.value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 10)
    this.rawCode = raw.toLowerCase()
  },

  join() {
    if (!this.isValid) {
      this.$refs.codeInput.focus()
      return
    }
    window.location.href = `https://meet.google.com/${this.displayCode}`
  },

  init() {
    this.$refs.codeInput.focus()
  },
}))

Alpine.start()
